import { ColumnDescription } from 'react-bootstrap-table-next';
import { IStockMaterialPart } from 'thunks/RTKQuery/parts';
import i18n from 'translations';
import moment from 'moment';

export const detailsColumns: ColumnDescription<any, IStockMaterialPart>[] = [
  {
    dataField: 'id',
    text: 'ID',
    hidden: true,
  },
  {
    dataField: 'logo',
    text: '',
    style: {
      width: '100px',
    },
  },
  {
    dataField: 'stockMaterial.name',
    text: i18n.t('partsView.detailColumns.stockMaterialName'),
    style: {
      width: '230px',
    },
  },
  {
    dataField: 'stockMaterial.guid',
    text: i18n.t('partsView.detailColumns.guid'),
    style: {
      width: '220px',
    },
  },
  {
    dataField: 'stockMaterial.lotNumber',
    text: i18n.t('partsView.detailColumns.lotNumber'),
    hidden: true,
  },
  {
    dataField: 'stockMaterial.material',
    text: i18n.t('partsView.detailColumns.material'),
    style: {
      width: '180px',
    },
  },
  {
    dataField: 'stockMaterial.blankType',
    text: i18n.t('partsView.detailColumns.blankType'),
    hidden: true,
  },
  {
    dataField: 'stockMaterial.storageLocation',
    text: i18n.t('partsView.detailColumns.storageLocation'),
    hidden: true,
  },
  {
    dataField: 'status',
    text: i18n.t('partsView.detailColumns.status'),
    style: {
      width: '220px',
    },
  },
  {
    dataField: 'isPreparedAutomatically',
    text: i18n.t('partsView.detailColumns.isPreparedAutomatically'),
    hidden: true,
    formatter: (cell: boolean) => (cell ? 'Yes' : 'No'),
  },
  {
    dataField: 'processId',
    text: i18n.t('partsView.detailColumns.processId'),
  },
  {
    dataField: 'failedReason',
    text: i18n.t('partsView.detailColumns.failedReason'),
    hidden: true,
  },
  {
    dataField: 'machineId',
    text: i18n.t('partsView.detailColumns.machineId'),
  },
  {
    dataField: 'created_at',
    text: i18n.t('partsView.columns.createdAt'),
    hidden: true,
    formatter: (_cell: any, row: IStockMaterialPart) =>
      moment(row.created_at).format('DD.MM.YYYY HH:mm'),
  },
  {
    dataField: 'updated_at',
    text: i18n.t('partsView.columns.updatedAt'),
    hidden: true,
    formatter: (_cell: any, row: IStockMaterialPart) =>
      moment(row.updated_at).format('DD.MM.YYYY HH:mm'),
  },
  {
    dataField: 'logo',
    text: '',
    style: {
      width: '400px',
    },
  },
];
